import React, { Component } from 'react'
import style from './style.module.less'
import BasicInfo from './basicInfo'
import DetailInfo from './detailInfo'
import { toJS } from 'mobx'
import { observer } from 'mobx-react'

@observer
class Index extends Component {
  render() {
    const { store, id } = this.props
    const detailData = toJS(store.detailData)
    return (
      <div className={style.left}>
        <BasicInfo store={store} detailData={detailData} id={id} />
        <DetailInfo store={store} detailData={detailData} id={id} />
      </div>
    )
  }
}

export default Index
